<template>
  <section id="offer-characteristics">
    <header>
      Характеристики
      <div
        v-if="product"
        class="legend"
      >
        <div class="attention-dot"/>
        <span>– имеется расхождение</span>
      </div>
    </header>

    <template v-if="localOffer">
      <dl
        v-for="charac in localOffer.characteristics"
        :key="charac.id"
        :class="{ 'cursor-pointer': product && charac.getMismatchByProduct(product) }"
        @mouseenter="product && $core.tooltip.show($event.currentTarget, charac.getMismatchByProduct(product))"
        @mouseleave="$core.tooltip.hide()"
      >
        <dt class="label">
          <div
            v-if="product && charac.getMismatchByProduct(product)"
            class="attention-dot"
          />
          {{ charac.name }}:&nbsp;
        </dt>
        <dd
        >
          {{ charac.valueStringRepresentation }}
        </dd>
      </dl>
    </template>
  </section>
</template>

<style lang="scss" src="./OfferCharacteristicsSection.scss" />

<script lang="ts">

import Offer         from '@/domains/Offers/Offer';
import Product       from '@/domains/Products/Product';
import OffersService from '@/domains/Offers/OffersService';

// Компонент занимает отображением характеристик. Если передать сюда продукт,
// то подсвечивает выход за референсные значения

export default defineComponent({
  name: 'OfferCharacteristicSection',

  props: {
    offer: {
      type:    Object as PropType<Offer>,
      default: null,
    },
    id: {
      type:    Number,
      default: null,
    },
    product: {
      type:    Object as PropType<Product>,
      default: null,
    },
  },

  data() {
    return {
      localOffer: null as Offer | null,
    };
  },

  created() {
    if (this.offer) {
      this.localOffer = this.offer;
    }
    else {
      this.loadOffer();
    }
  },

  methods: {
    async loadOffer(): Promise<void> {
      this.localOffer = await OffersService.get(this.id);
    },
  },
});

</script>
